import IsBetween from 'dayjs/plugin/isBetween';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import RelativeTime from 'dayjs/plugin/relativeTime';
import { extend as dayjsExtend } from 'dayjs';

export function initDayjs() {
  dayjsExtend(IsBetween);
  dayjsExtend(LocalizedFormat);
  dayjsExtend(RelativeTime);
}
